module.exports = __webpack_public_path__ + "img/scorpion-color2.2f68d4b6.png";